<template>
  <div>
    <div v-if="isAuthenticated" data-testid="app-authenticated-content">
      <WelcomeCurtain />
      <ImpersonateHeader v-if="showImpersonateNavbar" />
      <template v-if="isHomePageRoute">
        <AppNavbar />
        <MenuList data-testid="app-menu" />
      </template>
    </div>

    <div :class="appContainerClass" data-testid="app-container">
      <RouterViewWithTransition />
    </div>
  </div>
</template>
<script lang="ts">
import { Component, Prop, Vue } from 'vue-property-decorator';

import { ImpersonateHeader } from '@/modules/common/components/ImpersonateHeader';
import { AppNavbar } from '@/modules/common/components/AppNavbar';
import { MenuList } from '@/modules/common/components/MenuList';

import { WelcomeCurtain } from '@/modules/common/components/WelcomeCurtain';
import { RouterViewWithTransition } from '@/modules/common/components/RouterViewWithTransition';
import { isImpersonate } from '@/modules/common/services/partner';

@Component({
  components: {
    MenuList,
    WelcomeCurtain,
    ImpersonateHeader,
    AppNavbar,
    RouterViewWithTransition
  }
})
export default class AppContainer extends Vue {
  @Prop({ type: Boolean, required: true })
  readonly isAuthenticated!: boolean;

  get isHomePageRoute() {
    return this.$route.meta?.isHomePage;
  }

  get showImpersonateNavbar() {
    return isImpersonate();
  }

  get appContainerClass() {
    return {
      'app-template-container__impersonate': isImpersonate()
    };
  }
}
</script>

<style lang="less" scoped>
@navbar-impersonate: 48px;
@navbar-default: 56px;
@header-height-with-impersonate: @navbar-impersonate + @navbar-default;

.app-template-container__impersonate {
  margin-top: @navbar-impersonate;
  height: calc(100vh - @header-height-with-impersonate);
}
</style>
